import { FC } from 'react';
import dayjs from 'dayjs';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectResult } from 'store/player/playerSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';
import QuizTypes from 'types/QuizTypes';
import IQuiz from 'models/Quiz';

import classes from './styles.module.css';

const AppBar:FC = () => {
  const { t } = useTranslation();

  const result:any = useAppSelector(selectResult);
  const storeQuiz = useAppSelector(selectQuiz);
  const quiz:IQuiz | null = storeQuiz || result?.quiz || null;

  const quizName = result.quizGroup ? result.quizGroup.name : quiz?.quizName;
  const title = quiz
    ? quiz.publicLeaderboard.headerText || `${quizName} ${t('pages.leaderboard.title')}`
    : t('pages.leaderboard.leagueTitle');

  const quizEnded = dayjs().isAfter(Number(quiz?.endsDate));
  
  const logoImage = result.quizGroup ? result.quizGroup.logoImage : quiz?.logoImage;
  const logoBgColor = result.quizGroup ? result.quizGroup.logoImageBackgroundColor : quiz?.logoImageBackgroundColor;
  const primaryColor = result.quizGroup ? result.quizGroup.publicLeaderboard.primaryColor
    : quiz?.publicLeaderboard.primaryColor;

  if (!result) return null;
  return (
    <div
      className="
        relative z-40 overflow-hidden
        flex items-center justify-between gap-4
        flex-row portrait:flex-col
        py-2 mb-4
      "
      style={{ fontFamily: 'Montserrat' }}
    >
      <div className="flex-1">
        <h3
          className="text-xl sm:text-5xl font-extrabold uppercase text-center"
          style={{ color: primaryColor }}
        >
          {title}
        </h3>
        {quiz && quiz.type === QuizTypes.Prediction && quizEnded && (
          <p className="text-white text-center ml-1 sm:text-md">
            {result?.quiz.numberOfQuestions === result?.quiz.numberOfAnsweredQuestions
              ? t('pages.leaderboard.finalResults')
              : t('pages.leaderboard.answeredQuestions', { questions: result?.quiz.numberOfQuestions, answeredQuestions: result?.quiz.numberOfAnsweredQuestions })
            }
          </p>
        )}
      </div>
      <div className="flex-1 flex justify-around gap-8">
        <img src={logoImage} alt="logo" className={`${classes.logo} shadow-primary rounded-lg`} style={{ backgroundColor: logoBgColor }} />
        {quiz?.sponsorImage ? (
          <img src={quiz.sponsorImage} alt="sponsor-logo" className={`${classes.logo} shadow-primary rounded-lg`} style={{ backgroundColor: quiz?.sponsorImageBackgroundColor || 'none' }} />
        ) : null}
      </div>
    </div>
  )
}

export default AppBar;
